import { appConfig } from '../utils/appConfig';

// Interface for adding pay property to window.
declare global {
	interface Window {
		pay: any;
		gapi: any;
		grecaptcha: any;
		pca: any;
		embedded_svc: any;
	}
}

class RedwolfSdkAPI {
	public consentAPI: any;
	public pinAPI: any;
	public homeSetupAPI: any;
	public authAPI: any;
	public customerSupportAPI: any;
	public cartsAPI: any;
	public ordersAPI: any;
	public payAPI: any;
	public productsAPI: any;
	public subscriptionAPI: any;
	public accountAPI: any;

	constructor() {
		this.consentAPI = null;
		this.pinAPI = null;
		this.homeSetupAPI = null;
		this.authAPI = null;
		this.customerSupportAPI = null;
		this.cartsAPI = null;
		this.ordersAPI = null;
		this.payAPI = null;
		this.productsAPI = null;
		this.subscriptionAPI = null;
		this.accountAPI = null;
		this.setRedwolfSdkAPI();
	}

	setRedwolfSdkAPI() {
		if (window.pay && window.pay.com) {
			// www-dev.vizio.com or localhost:8080
			let environment: any = window.pay.com.vizio.pay.api.JsEnvironmentGroup.DEV;

			if (window.location.href.includes('www-stage.vizio.com')) {
				environment = window.pay.com.vizio.pay.api.JsEnvironmentGroup.STAGE;
			} else if (window.location.href.includes('www-preprod.vizio.com')) {
				environment = window.pay.com.vizio.pay.api.JsEnvironmentGroup.PREPROD;
			} else if (window.location.href.includes('www.vizio.com')) {
				environment = window.pay.com.vizio.pay.api.JsEnvironmentGroup.PROD;
			}

			this.consentAPI = new window.pay.com.vizio.pay.api.ConsentV2ProxyJsApi(
				environment.toSDKConsentV2ProxyEnvironment()
			);

			this.pinAPI = new window.pay.com.vizio.pay.api.PurchasePinJsApi(
				environment.toSDKPinEnvironment()
			);

			const sdkPayEnvironment: any = environment.toSDKPayEnvironment(appConfig.subscriptionKey);

			this.homeSetupAPI = new window.pay.com.vizio.pay.api.HomeSetupJsApi(
				environment.toSDKHomeSetupEnvironment(appConfig.dmsJwt, appConfig.subscriptionKey),
				sdkPayEnvironment
			);

			this.authAPI = new window.pay.com.vizio.pay.api.PayAuthJsApi(sdkPayEnvironment);
			this.customerSupportAPI = new window.pay.com.vizio.pay.api.CustomerSupportJsApi(
				sdkPayEnvironment
			);
			this.cartsAPI = new window.pay.com.vizio.pay.api.CartsJsApi(sdkPayEnvironment);
			this.ordersAPI = new window.pay.com.vizio.pay.api.OrdersJsApi(sdkPayEnvironment);
			this.payAPI = new window.pay.com.vizio.pay.api.PayJsApi(sdkPayEnvironment);
			this.productsAPI = new window.pay.com.vizio.pay.api.ProductsJsApi(sdkPayEnvironment);
			this.subscriptionAPI = new window.pay.com.vizio.pay.api.SubscriptionJsApi(sdkPayEnvironment);
			this.accountAPI = new window.pay.com.vizio.pay.api.AccountJsApi(sdkPayEnvironment);
		}
	}
}

export const {
	consentAPI,
	pinAPI,
	homeSetupAPI,
	authAPI,
	customerSupportAPI,
	cartsAPI,
	ordersAPI,
	payAPI,
	productsAPI,
	subscriptionAPI,
	accountAPI
} = new RedwolfSdkAPI();
